import createAsyncSlice from './helper/createAsyncSlice';

export const API_URL = 'https://entradafranca.com/api';

let climatempo = createAsyncSlice({
  name: 'climatempo',
  initialState: {
    list: [],
    user: 0,
    pages: 0,
    infinite: true,
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
    },
    clearPhotos(state, action) {
      state.list = [];
    },
    addPhotos(state, action) {
      state.list.push(action.payload);
      //console.log(action.payload)
      //state.list.sort(function (a, b) {return b.total - a.total })
      //state.pages++;
      //if (action.payload.meta.current_page === action.payload.meta.last_page) state.infinite = false;
    },
    removePhotos(state) {
      state.pages = 0;
      state.infinite = true;
      state.list = [];
      state.data = null;
    },
    searchbyTitle(state, action) {

      const data = action.payload.payload.data;
      const overFiveKg = data?.filter(({ title }) => title.toUpperCase().indexOf(action.payload.chave.toUpperCase()) > -1);
      const transformPound = overFiveKg?.map((photo) => ({
        ...photo,
        peso: Math.floor(photo.peso * 5.2),
      }));

      state.list.push(...transformPound);
      state.infinite = false;
    },
  },
  fetchConfig: (data) => ({
    url: `https://api.openweathermap.org/data/2.5/weather?lat=-30.0277&lon=-51.2287&appid=4e010b936c2cab40b3ea5e5c31855342&lang=pt_br`,
    options: {
      method: 'GET',
      cache: 'no-store',
    },
  }),
});

const slice = createAsyncSlice({
  name: 'photos',
  initialState: {
    cache: 5000,
    list: [],
    user: 0,
    pages: 0,
    infinite: true,
  },
  fetchConfig: () => ({
    url:
    `https://api.openweathermap.org/data/2.5/weather?lat=-30.0277&lon=-51.2287&appid=4e010b936c2cab40b3ea5e5c31855342`,
    options: {
      method: 'GET',
      cache: 'no-store',
    },
  }),
});


export const {  addPhotos, addPhotos2, searchbyTitle, setUser, clearPhotos, removePhotos } = climatempo.actions;
export const fetchPhotos = climatempo.asyncAction;
export const fetchPhotos2 = slice.asyncAction;

export const getOverFiveKg = (state) => {
  const data = state;
  const overFiveKg = data?.filter(({ peso }) => peso >= 0);
  const transformPound = overFiveKg?.map((photo) => ({
    ...photo,
    peso: Math.floor(photo.peso * 2.2),
  }));
  return transformPound;
};

export const getbyTitle = (state, chave) => {
  console.log(chave);
  const data = state;

  const overFiveKg = data?.filter(({ title }) => title.indexOf(chave) > -1);
  const transformPound = overFiveKg?.map((photo) => ({
    ...photo,
    peso: Math.floor(photo.peso * 5.2),
  }));
  return transformPound;
};

export const loadClima = (page = 1, user = 0) => async (dispatch) => {
  const { payload } = await dispatch(fetchPhotos({page, user}));
  dispatch(addPhotos(payload));
};

export const searchTitle = (chave = '',user = 0) => async (dispatch) => {
  const { payload } = await dispatch(fetchPhotos({user:user}));
  dispatch(removePhotos());
  dispatch(searchbyTitle({payload, chave}));
};

export const loadNewPhotosInicial = (page = 1, user = 0) => async (dispatch) => {
  const { payload } = await dispatch(fetchPhotos({page, user}));
  dispatch(removePhotos());
  dispatch(addPhotos(payload));
};

export default climatempo.reducer;
